import type { SimulationResponseType, SimulationType } from '../type/simulation.type'

export function mapSimulationData(id: string, originalData: SimulationType) {
  return {
    id,
    borrowers: originalData.insurances.person.map((person) => ({
      monthlyAmount: person.monthlyAmount,
      totalAmount: person.totalAmount,
      medicalSurvey: person.medicalSurvey,
    })),
    legalNotices: originalData.legalNotices?.html.replace('{projectType}', ''),
    legalNoticesHtml: originalData.legalNotices?.html.replace('{projectType}', ''),
    depositAmount: originalData.depositAmount,
    purchaseAmount: originalData.purchaseAmount,
    numberOfPayments: originalData.numberOfPayments,
    scaleId: originalData.loanInformation.scaleId,
    scaleTypeCode: originalData.loanInformation.scaleTypeCode,
    contractPeriod: originalData.loanInformation.contractPeriod,
    annualPercentageRate: originalData.loanInformation.financialResult.annualPercentageRate,
    nominalRate: originalData.loanInformation.financialResult.nominalRate,
    fixedBorrowingRate: originalData.loanInformation.financialResult.fixedBorrowingRate,
    fees: originalData.loanInformation.financialResult.fees,
    sellersCost: originalData.loanInformation.financialResult.sellersCost,
    loanAmount: originalData.loanInformation.financialResult.loanAmount,
    monthlyPaymentNoInsurance: originalData.loanInformation.financialResult.monthlyPaymentInsuranceNotIncluded,
    monthlyPaymentWithInsurance: originalData.loanInformation.financialResult.monthlyPaymentInsuranceIncluded,
    totalInterestAmount: originalData.loanInformation.financialResult.totalInterestAmount,
    insuranceAnnualPercentageRate: originalData.loanInformation.financialResult.insuranceAnnualPercentageRate,
    totalAmountWithInsurance: originalData.loanInformation.financialResult.totalAmountInsuranceIncluded,
    totalAmountNoInsurance: originalData.loanInformation.financialResult.totalAmountInsuranceNotIncluded,
  }
}

export function mapResponseData(originalData: SimulationResponseType) {
  return {
    simulation: mapSimulationData('main-result', originalData.mainResult),
    variations: originalData.variations
      ? Object.keys(originalData.variations).map((key) =>
          originalData.variations ? mapSimulationData(key, originalData.variations[key]) : null,
        )
      : undefined,
    legalNotice: originalData.mainResult.legalNotices?.html.replace('{projectType}', ''),
    legalNoticeHtml: originalData.mainResult.legalNotices?.html.replace('{projectType}', ''),
  }
}
